import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import MenuBar from "./MenuBar";
import { NavDropdown } from "react-bootstrap";
import "../../external.css"
import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice";
// import GoogleTranslate from "./GoogleTranslate"

export const Header = () => {
   const dispatch = useDispatch();
  
  const [isSticky, setIsSticky] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isIndustryHovered, setIsIndustryHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);
  
  const handleIndustryMouseEnter = useCallback(() => {
    setIsIndustryHovered(true);
  }, []);
  
  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);
  
  const handleIndustryMouseLeave = useCallback(() => {
    setIsIndustryHovered(false);
  }, []);
  
  const handleToggleMenu = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);
  
  const handleLinkClick = useCallback(() => {
    setIsHovered(false); 
    setIsIndustryHovered(false);
  }, []);

  const handleScroll = useCallback(() => {
    setIsSticky(window.scrollY > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <>    
      <div className={`header-area ${isSticky ? "stick" : ""}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-5 col-lg-2 col-md-3">
              <div className="logo">
                <Link to={"/"}><img width={140} height={54} src="/assets/Logo1.webp" alt="Logo" className="img-responsive"/></Link>
              </div>
            </div>

            <div className="col-7 col-lg-10 col-md-9">
              <nav className="header-menubar">
                <ul className="header-menulink">
                  <li onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <NavDropdown id="nav-dropdown-dark-example" title="SOLUTIONS" menuVariant="light" show={isHovered} >
                      <div className="solution-bigmenu">
                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon1.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/shuttle-software" onClick={handleLinkClick}>Shuttle Software</Link>
                                  <p>Manage and streamline your shuttle services with ease.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon2.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/car-rental-software" onClick={handleLinkClick}>Car Rental Software</Link>
                                  <p>Efficiently handle rentals and reservations for your fleet.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon3.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/best-taxi-dispatch-software" onClick={handleLinkClick}>Taxi Dispatch Software</Link>
                                  <p>Optimize dispatching and improve taxi service management.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon5.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/white-label-solutions" onClick={handleLinkClick}>White Label Solutions</Link>
                                  <p>Customize software to match your brand and business needs.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon4.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>Carpool & Rideshare Software</Link>
                                  <p>Enable smooth and efficient carpool and rideshare solutions.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-bike.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/bike-rental" onClick={handleLinkClick}>Bike Rental Software</Link>
                                  <p>Efficiently manage and scale your bike-sharing services with ease.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-airport.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/airport-transfer-software" onClick={handleLinkClick}>Airport transfer software</Link>
                                  <p>Future proof your taxi operations to compete in this digital age.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-custom-app.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to={"/custom-app-development"} onClick={handleLinkClick}>custom app development</Link>
                                  <p>Boost your business with a custom app designed for the digital age.</p>
                              </div>
                          </div>

                          <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-web-app.webp" alt="icon" loading="lazy"/> 
                              <div>
                                  <Link to="/web-app-development" onClick={handleLinkClick}>web app development</Link>
                                  <p>The web app to take your business to an escalated extent.</p>
                              </div>
                          </div>
                      </div>

                      {/* <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon1.webp" alt="icon"/> 
                        <Link to="shuttle-software">Shuttle Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon2.webp" alt="icon"/> 
                        <Link to="car-rental-software">Car Rental Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon3.webp" alt="icon"/> 
                        <Link to="/best-taxi-dispatch-software">Taxi Dispatch Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon4.webp" alt="icon"/> 
                        <Link to="/white-lable-carpool-app-dispatch-software">Carpool & Rideshare Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon5.webp" alt="icon"/> 
                        <Link to="/white-label-solutions">White Label Solutions</Link>
                      </NavDropdown.Item> */}
                    </NavDropdown>
                  </li>

                  <li onMouseEnter={handleIndustryMouseEnter} onMouseLeave={handleIndustryMouseLeave}>
                    <NavDropdown id="nav-dropdown-dark-example" title="INDUSTRIES" menuVariant="light" show={isIndustryHovered}>
                      <div className="industry-menu-scroll">
                        <div className="solution-bigmenu industries-menu-wrap">

                          <div className="industries-big-menu">
                            <h4>on demand</h4>
                            
                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-food.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/food-grocery-delivery-app-development-company" onClick={handleLinkClick}>food delivery</Link>
                                </div>
                            </div>  

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-grocery.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/food-grocery-delivery-app-development-company" onClick={handleLinkClick}>grocery delivery</Link>
                                </div>
                            </div>  

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-ecom.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/ecommerce-mobile-app-development-company" onClick={handleLinkClick}>E-Commerce delivery</Link>
                                </div>
                            </div> 
                            
                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-restr.webp" alt="icon"/> 
                                <div>
                                    <Link to="/restaurant-app-development-company" onClick={handleLinkClick}>restaurant app</Link>
                                </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-pharm.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/best-pharmacy-app-development-company" onClick={handleLinkClick}>pharmacy delivery</Link>
                                </div>
                            </div> 


                            
                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-pickup.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>pickup delivery</Link>
                                </div>
                            </div>*/}
                          </div> 

                          <div className="industries-big-menu">
                            <h4>services</h4>
                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-taxi.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/best-taxi-dispatch-software" onClick={handleLinkClick}>taxi & transportation</Link>
                                  </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-airport1.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/airport-transfer-software" onClick={handleLinkClick}>Airport Taxi</Link>
                                </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-shuttle.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/shuttle-software" onClick={handleLinkClick}>shuttle services</Link>
                                </div>
                            </div>  

                            {/* <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-carpool.webp" alt="icon"/> 
                                <div>
                                    <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>car pooling</Link>
                                </div>
                            </div>  */}

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-bikerent.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/bike-rental" onClick={handleLinkClick}>bike rental</Link>
                                </div>
                            </div> 

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-Concierge.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>Concierge</Link>
                                  </div>
                            </div>*/}
                            
                          </div> 

                          <div className="industries-big-menu">
                            <h4>others</h4>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-logistic.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/best-logistic-app-development-company" onClick={handleLinkClick}>Logistics</Link>
                                  </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-foodgrocery.webp" alt="icon"/> 
                                <div>
                                    <Link to="/food-and-grocery-app" onClick={handleLinkClick}>food & grocery</Link>
                                  </div>
                            </div>*/}

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-mobility.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>mobility</Link>
                                  </div>
                            </div>*/}

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-health.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/custom-healthcare-app-development-services" onClick={handleLinkClick}>Healthcare</Link>
                                </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-education.webp" alt="icon"/> 
                                <div>
                                    <Link to="/education-app-development-services" onClick={handleLinkClick}>education</Link>
                                  </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-telemedicine.webp" alt="icon"/> 
                                <div>
                                    <Link to="/telemedicine-app-development-company" onClick={handleLinkClick}>telemedicine</Link>
                                  </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-fitness.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>fitness</Link>
                                  </div>
                            </div>*/}
                          </div> 

                          <div className="industries-big-menu">
                            <h4>marketplace</h4>
                            
                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-service.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>service</Link>
                                </div>
                            </div>*/}

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-rental.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/car-rental-software" onClick={handleLinkClick}>Car Rental</Link>
                                </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-freelance.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>freelancer</Link>
                                </div>
                            </div>*/}

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-ecom1.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/ecommerce-mobile-app-development-company" onClick={handleLinkClick}>e-commerce</Link>
                                </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-peer.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>peer to peer</Link>
                                </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-fintech.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>fintech</Link>
                                </div>
                            </div>*/}

                          </div> 

                          <div className="industries-big-menu">
                            <h4>solutions</h4>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-ondemand.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>on demand app</Link>
                                </div>
                            </div> */}

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-carpoolshare.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>Carpool & ride sharing app</Link>
                                </div>
                            </div> 

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-whitelabel1.webp" alt="icon" loading="lazy"/> 
                                <div>
                                    <Link to="/white-label-solutions" onClick={handleLinkClick}>white label solutions</Link>
                                </div>
                            </div> 
                            

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-consult.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>consultation app</Link>
                                </div>
                            </div> */}

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-dating.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>dating app</Link>
                                </div>
                            </div>*/}

                            
                          </div> 
                        </div>

                        <div className="industry-menu-exclusive">
                          <Link to={"/white-label-solutions"}>
                            <div className="exclusive-btn">
                              <div>
                                <span><span>exclusive</span></span>
                                <label>Custom White Lable Solutions <p>(All-in-one App Solution)</p></label>
                              </div>
                              <span className="exclusive-btn-togo">explore</span>
                            </div>
                          </Link>
                          <div className="bookdemo-industry-menu">
                            <Link onClick={() => dispatch(openPopup())} to={""}>BOOK FREE DEMO</Link>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                  </li>

                  <li><Link to={"/about"}>Company</Link></li>
                  <li><Link to={"/pricing"}>Pricing</Link></li>
                </ul>

                <Link to={"/contact"} className="header-butn">Contact Us</Link>

                {/* <GoogleTranslate/> */}

                <div className="btn1" onClick={handleToggleMenu}>
                  <div className="menu-line icon-top"></div>
                  <div className="menu-line icon-center"></div>
                  <div className="menu-line icon-bottom"></div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <MenuBar isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
